angular.module('unica_event_field.event_field_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// EVENT FIELD
		.state('app.event_field', {
			url: '/event-field',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/event-field/templates/event-field.html',
					controller: 'EventFieldBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// EVENT FIELD LIST
			.state('app.event_field.list', {
				url: '/list/:event_id',
				views: {
					'eventFieldContent': {
						templateUrl: './modules/event-field/templates/list.html',
						controller: 'EventFieldListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Campi Personalizzati',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// EVENT FIELD CREATE
			.state('app.event_field.create', {
				url: '/create/:event_id',
				views: {
					'eventFieldContent': {
						templateUrl: './modules/event-field/templates/create.html',
						controller: 'EventFieldCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Campo',
					parent: 'app.event_field.list'
				}
			})

			// EVENT FIELD EDIT
			.state('app.event_field.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'eventFieldContent': {
						templateUrl: './modules/event-field/templates/edit.html',
						controller: 'EventFieldEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Campo',
					parent: 'app.event_field.list'
				}
			});


});

